export const legalDocumentSection = '/legal';

export const legalDocumentPath = legalDocumentSection + '/:slug';

export const termsOfServicePath = `${legalDocumentSection}/terms-of-service`;
export const privacyPolicyPath = `${legalDocumentSection}/privacy-policy`;
export const termsPath = `${legalDocumentSection}/terms`;
export const apiDocumentationPath = '/api-docs';
export const apiDocumentationExternalUrl = 'https://docs.bhutanpayments.com/';
export const disputeEvidenceBestPracticesPath = `${legalDocumentSection}/dispute-evidence-best-practices`;
